import { SignupSteps } from '../enums/signup-steps.enum';

export const getSignupFlowStepCount = (step: SignupSteps, steps: string[]): number => steps.indexOf(step) + 1;
